import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { showErrorToast, showSuccessToast } from "#app/notifications";
import { connectUser, ConnectUserError } from "#modules/company/infra/connectUser.api";

type Option = {
  onSuccess?: () => void;
};

export const useConnectUser = (options?: Option) => {
  const { t } = useTranslation();

  const { mutate, ...rest } = useMutation({
    mutationFn: connectUser,
    onSuccess: () => {
      showSuccessToast({
        title: "Companie connectée avec succès",
        message: "Veuillez vous reconnecter pour terminer l'inscription",
      });
      options?.onSuccess?.();
    },
    onError: (error) => {
      if (error instanceof ConnectUserError) {
        showErrorToast({
          title: t(`errors.connectUser.${error.code}`),
        });
      } else {
        showErrorToast({
          title: t("errors.connectUser.CONNECTION_FAILED"),
        });
      }
    },
  });

  return { connectUser: mutate, ...rest };
};
